@let request = $request();
@let canDeleteFiles = permissionService.canDeleteFiles$ | async;
@let viewOnly = $viewOnly();
@let isMobile = deviceService.isMobile$ | async;

<ng-template #imagePreview let-imagePreviewObserver>
  <tui-preview
    [rotatable]="true"
    [zoomable]="true"
    (click)="backdropClickClose($event, imagePreviewObserver)"
    (tuiSwipe)="onSwipePreviewImage($event)"
  >
    @if (currentPreviewImage && currentPreviewImage.filename) {
      <tui-preview-title>{{ currentPreviewImage.filename }}</tui-preview-title>
    }
    <tui-preview-pagination
      [length]="previewImagesLength"
      [(index)]="previewImageIndex"
    ></tui-preview-pagination>
    @if (!viewOnly) {
      <button
        iconStart="@tui.trash"
        title="Delete"
        tuiIconButton
        tuiPreviewAction
        type="button"
        [tuiHint]="
          canDeleteFiles
            ? ''
            : ('request_form.files.hint_request_to_delete' | translate) +
              currentPreviewImage!.filename
        "
        (click)="
          canDeleteFiles
            ? deleteFile(currentPreviewImage!, imagePreviewObserver)
            : createFileDeleteRequest(
                currentPreviewImage!,
                imagePreviewObserver
              )
        "
      ></button>
    }

    <button
      iconStart="@tui.download"
      title="Download"
      tuiIconButton
      tuiPreviewAction
      type="button"
      (click)="downloadPreviewImage()"
    ></button>
    <button
      iconStart="@tui.x"
      title="Close"
      tuiIconButton
      tuiPreviewAction
      type="button"
      (click)="closeImagePreview(imagePreviewObserver)"
    ></button>
    @if (getCurrentPreviewImage() && fileIsImage(currentPreviewImage!)) {
      <img
        alt="preview"
        [src]="src"
        *polymorpheusOutlet="getCurrentPreviewImageSrc() as src"
      />
    } @else {
      <span
        [tuiAvatar]="'@tui.file'"
        [round]="false"
        size="xxl"
        class="bg-[#F2F2F2]!"
        new
      ></span>
    }

    @if (request?.vin) {
      <div
        class="mt-4 x-text-primary text-center absolute top-10"
        tuiPreviewAction
      >
        <h4
          class="typo-h4 cursor-pointer"
          (click)="copyVinToClipboard(request.vin)"
        >
          VIN: {{ request.vin }}
        </h4>
      </div>
    }
    @let previewImage = $any(currentPreviewImage);
    @if (previewImage && previewImage.filename && isMobile) {
      <div
        class="mt-4 absolute x-text-primary"
        tuiPreviewAction
        [ngClass]="{
          'top-20': request.vin,
          'top-10': !request.vin,
        }"
      >
        @if (currentPreviewImageCatName) {
          <h4 class="x-font-body-3-bold text-right">
            {{ currentPreviewImageCatName }}
          </h4>
          <p class="x-font-body-4 opacity-75">
            {{ previewImage.filename }}
          </p>
        } @else {
          <h4 class="x-font-body-4">
            {{ previewImage.filename }}
          </h4>
        }
      </div>
    }
  </tui-preview>
</ng-template>
